/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

type Symbol = "INFO" | "WARNUNG" | "FEHLER" | "LAUFEND" | "ERFOLG";

export default Symbol;

export class Symbole {
    public static readonly info: Symbol = "INFO";
    public static readonly warnung: Symbol = "WARNUNG"
    public static readonly fehler: Symbol = "FEHLER"
    public static readonly laufend: Symbol = "LAUFEND"
    public static readonly erfolg: Symbol = "ERFOLG"
}